import React from 'react'

const ClientRow = ({ client }) => {
  return (
    <tr>
      <td>{client.name}</td>
      <td>{client.email}</td>
      <td>{client.phone}</td>
      <td>{client.created_at}</td>
      <td>
        <button>Preencher Consulta</button>
        <button>Cadastrar Plano</button>
      </td>
    </tr>
  )
}

export default ClientRow
